// Lightweight Cloudflare Turnstile helper.
// Loads the script once, creates an invisible widget, and exposes getToken().
// With test keys (1x000...AA) the widget resolves instantly.

const SRC = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
const SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY || "";

let _scriptPromise = null;

function loadScript() {
  if (_scriptPromise) return _scriptPromise;
  _scriptPromise = new Promise((resolve, reject) => {
    if (typeof window !== "undefined" && window.turnstile) {
      resolve(window.turnstile);
      return;
    }
    const s = document.createElement("script");
    s.src = SRC;
    s.async = true;
    s.defer = true;
    s.onload = () => {
      // turnstile global may take a tick
      const poll = setInterval(() => {
        if (window.turnstile) { clearInterval(poll); resolve(window.turnstile); }
      }, 50);
      setTimeout(() => { clearInterval(poll); reject(new Error("turnstile timeout")); }, 10000);
    };
    s.onerror = () => reject(new Error("turnstile script failed"));
    document.head.appendChild(s);
  });
  return _scriptPromise;
}

export async function getTurnstileToken() {
  if (!SITE_KEY) return ""; // disabled
  try {
    const ts = await loadScript();
    return await new Promise((resolve) => {
      const container = document.createElement("div");
      container.style.position = "fixed";
      container.style.left = "-9999px";
      container.style.bottom = "-9999px";
      document.body.appendChild(container);
      let settled = false;
      const finish = (tok) => {
        if (settled) return;
        settled = true;
        try { ts.remove(widgetId); } catch (e) { /* noop */ }
        try { document.body.removeChild(container); } catch (e) { /* noop */ }
        resolve(tok || "");
      };
      const widgetId = ts.render(container, {
        sitekey: SITE_KEY,
        size: "invisible",
        callback: (token) => finish(token),
        "error-callback": () => finish(""),
        "expired-callback": () => finish(""),
        "timeout-callback": () => finish(""),
      });
      try { ts.execute(widgetId); } catch (e) { finish(""); }
      setTimeout(() => finish(""), 8000); // hard cap
    });
  } catch {
    return "";
  }
}
